import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import StatusBarInfoBox from "../../components/StatusBarInfoBox/StatusBarInfoBox";

// tslint:disable-next-line:no-var-requires
const style = require("./PinScreenLayout.scss");

export interface PinScreenLayoutProps {
    children: React.ReactNode;
    titleKey: "newPIN" | "PIN";
}

export function PinScreenLayout({
    children,
    t,
    titleKey
}: PinScreenLayoutProps & WithTranslation) {
    return (
        <div className={style.whiteScreen}>
            <div className={style.breadcrumb}>
                <StatusBarInfoBox>{t("title")}</StatusBarInfoBox>
            </div>
            <div className={style.centeredContent}>
                <span className={style.headerText}>{t(titleKey)}</span>
                {children}
            </div>
        </div>
    );
}

export default withTranslation("pinScreen")(PinScreenLayout);
